(() => {
  if (window.gxPdpCalloutMotion) return;
  const selector = '.gx-pdp-callout';
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');

  function init(section) {
    if (section._gxCalloutAbort) return;
    const visual = section.querySelector('.gx-pdp-callout__visual');
    const markers = [...visual.querySelectorAll('.gx-hotspot')];
    const featureLabels = [...section.querySelectorAll('.gx-pdp-callout__features li')];
    if (!markers.length) return;
    const controller = new AbortController();
    const { signal } = controller;
    let visible = false;
    let manual = null;
    let hovered = null;
    let frame = 0;
    section._gxCalloutAbort = controller;
    section.dataset.gxCalloutReady = 'true';
    section.dataset.gxCalloutVisible = 'false';

    function activate(marker) {
      if (marker && getComputedStyle(marker).display === 'none') return;
      markers.forEach((item, index) => {
        const active = item === marker;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
        featureLabels[index]?.classList.toggle('is-active', active);
      });
      if (marker) section.dataset.gxCalloutActive = String(markers.indexOf(marker) + 1);
      else delete section.dataset.gxCalloutActive;
    }
    function sync() {
      frame = 0;
      if (!visible) return;
      const desktopPointer = finePointer.matches && innerWidth >= 990;
      const focused = desktopPointer && document.activeElement?.matches?.('.gx-pdp-callout .gx-hotspot:focus-visible') ? document.activeElement : null;
      activate(hovered || focused || manual || null);
    }
    function queue() {
      if (!frame) frame = requestAnimationFrame(sync);
    }
    const observer = new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      section.dataset.gxCalloutVisible = String(visible);
      if (visible) {
        section.dataset.gxCalloutEntered = 'true';
        queue();
      }
    }, { threshold: 0 });
    observer.observe(section);

    markers.forEach((marker, index) => {
      marker.style.setProperty('--gx-callout-order', index);
      marker.setAttribute('role', 'button');
      marker.tabIndex = 0;
      marker.setAttribute('aria-pressed', 'false');
      marker.addEventListener('pointerenter', () => {
        if (finePointer.matches && innerWidth >= 990) { hovered = marker; queue(); }
      }, { signal });
      marker.addEventListener('pointerleave', () => { hovered = null; queue(); }, { signal });
      marker.addEventListener('focus', () => activate(marker), { signal });
      marker.addEventListener('blur', queue, { signal });
      marker.addEventListener('click', () => { manual = marker; activate(marker); }, { signal });
      marker.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        manual = marker;
        activate(marker);
      }, { signal });
    });
    visual.addEventListener('pointerleave', () => { hovered = null; queue(); }, { signal });
    addEventListener('scroll', () => { manual = null; queue(); }, { signal, passive: true });
    addEventListener('resize', queue, { signal, passive: true });
    signal.addEventListener('abort', () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
      markers.forEach((marker) => {
        marker.classList.remove('is-active');
        marker.removeAttribute('role');
        marker.removeAttribute('tabindex');
        marker.removeAttribute('aria-pressed');
        marker.style.removeProperty('--gx-callout-order');
      });
      featureLabels.forEach((label) => label.classList.remove('is-active'));
      delete section.dataset.gxCalloutReady;
      delete section.dataset.gxCalloutVisible;
      delete section.dataset.gxCalloutEntered;
      delete section.dataset.gxCalloutActive;
      delete section._gxCalloutAbort;
    }, { once: true });
  }
  function mount(root = document) {
    if (root.matches?.(selector)) init(root);
    root.querySelectorAll(selector).forEach(init);
  }
  window.gxPdpCalloutMotion = { mount };
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches?.(selector)) event.target._gxCalloutAbort?.abort();
    event.target.querySelectorAll(selector).forEach((section) => section._gxCalloutAbort?.abort());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
})();
